module.exports = __webpack_public_path__ + "static/logo-56531963cf93de5e32b5e25b556792c6.png";